import { Typography } from "@material-ui/core";
import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from "react-router-dom";

const drawerWidth = 240;

export const LogoText = styled.span`
  font-size: 22px;
  font-family: Ink;
  color: var(--color-yellow);
`;

export const AppBarCenter = styled(Typography)`
    flex-grow: 1;
    text-align: center !important;
`;

export const MenuLink = styled(Link)`
  color: var(--color-white);
`;

export const MainLogo = styled.img`
  height: calc(100vh - 225px);
  width: auto;
  margin: auto;

  @media (max-width: 400px) {
    height: 260px;
  }
`;

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  instyleAppBar: {
    zIndex: "1201 !important",
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    backgroundColor: 'var(--color-black) !important'
  },
  instyleAppBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    zIndex: "1199 !important"
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    backgroundColor: "var(--color-black) !important",
    color: "var(--color-white) !important"
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9) + 1,
    },
    backgroundColor: "var(--color-black) !important",
    color: "var(--color-white) !important"
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    width: `calc(100% - ${drawerWidth}px)`,
    height: "100vh",
    maxHeight: "calc(100vh - 85px - 30px)",
    overflow: "scroll",
    display: "flex",
    flexDirection: "column",
  },
}));